import { Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';

const VerticalData = ({label, data}) => {
    return ( 
        <div>
            <Typography variant='body2' style={{color:'#696969'}} >{label}</Typography>
            <Typography>{data}</Typography>
        </div>

     );
}
 
export default VerticalData;